import { mockDelay } from '@/services/factory'
import type { PracticeGovernanceService } from './practiceGovernance.service'
import type { GovernanceSnapshot, WorkloadGroupBy } from '@/types/practiceGovernance.types'

const id = () => crypto.randomUUID()
const now = () => new Date().toISOString()

export function createMockPracticeGovernanceService(): PracticeGovernanceService {
  const snapshot: GovernanceSnapshot = {
    branches: [{ id: 'branch-pune', code: 'PUNE', name: 'Pune Main', isActive: true }],
    teams: [{ id: 'team-direct-tax', branchId: 'branch-pune', code: 'DIRECT', name: 'Direct Tax', isActive: true }],
    portfolios: [{ id: 'portfolio-growth', branchId: 'branch-pune', teamId: 'team-direct-tax', code: 'GROWTH', name: 'Growth Businesses', ownerUserId: 'partner-1', reviewerUserId: 'owner-1', isActive: true }],
    memberships: [{ id: 'membership-1', userId: 'assistant-1', branchId: 'branch-pune', teamId: 'team-direct-tax', scopedRole: 'technical_assistant', isPrimary: true, validFrom: now() }],
    crossBranchPolicies: [],
    reviewPolicies: [{ id: 'policy-1', name: 'High-value filing review', workflowType: 'assessment_filing', riskLevels: ['high'], minValue: 100000, requiredReviewerRoles: ['partner'], makerCheckerRequired: true, escalationHours: 24, priority: 100, active: true }],
    delegations: [],
    workload: [{ key: 'assistant-1', total: 8, open: 5, reviewRequested: 2, accepted: 3, rejected: 0, overdue: 1, escalated: 1 }],
    escalations: [{ id: 'escalation-1', subjectType: 'assistant_work', subjectId: 'work-8', escalatedToUserId: 'partner-1', reason: 'Review SLA exceeded', dueAt: now(), createdAt: now() }],
  }
  const done = async () => { await mockDelay(120) }
  return {
    async getSnapshot(_groupBy: WorkloadGroupBy) { await done(); return structuredClone(snapshot) },
    async createBranch(input) { await done(); snapshot.branches.push({ id: id(), ...input, isActive: true }) },
    async createTeam(input) { await done(); snapshot.teams.push({ id: id(), ...input, isActive: true }) },
    async createPortfolio(input) { await done(); snapshot.portfolios.push({ id: id(), ...input, isActive: true }) },
    async createMembership(input) { await done(); snapshot.memberships.push({ id: id(), ...input, validFrom: now() }) },
    async createCrossBranchPolicy(input) { await done(); snapshot.crossBranchPolicies.push({ id: id(), ...input, validFrom: now() }) },
    async createReviewPolicy(input) { await done(); snapshot.reviewPolicies.push({ id: id(), ...input, active: true }) },
    async createDelegation(input) { await done(); snapshot.delegations.push({ id: id(), ...input }) },
    async runEscalations() { await done() },
  }
}
